export default "__VITE_ASSET__B$bSMsxu__"